var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loggedIn)?_c('b-container',{staticClass:"competitions",attrs:{"nogutter":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }